import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import ConfirmDeletePopup from '../Controls/ConfirmDeletePopup.js';

import './CategoryList.css';

class CategoryList extends Component {

    confirmDeletePopup = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            assets: []
        };
    }

    componentDidMount() {
        fetch('category_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=0&pageSize=10"
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ categories: data });
        })
        .catch(console.log)

        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all assets
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ assets: data });
        })
        .catch(console.log)
    }

    reloadList = (startIndex, pageSize) => {
        fetch('category_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + startIndex + "&pageSize=" + pageSize
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ categories: data });
        })
        .catch(console.log)
    }

    handleDelete = categoryId => event => {
        event.preventDefault();
        this.confirmDeletePopup.current.request(() => this.performDelete(categoryId));
    }

    performDelete = (categoryId) => {

        //const name = ReactDOM.findDOMNode(this._nameInput).value;
        //console.log(event.target.name);
        //console.log(event.target.value);
        fetch('category_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            body: "categoryId=" + categoryId
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].delete)
            {
                this.props.reloadCategories();
            }
        })
        .catch(console.log)
    }

    showUpdateCategory = (category) => {
        this.props.showUpdateCategory(category);
    }

    getAssetName = (assetId) => {
        for (let i = 0; i < this.state.assets.length; i++) {
            if (String(this.state.assets[i].assetId) === String(assetId)) {
                return this.state.assets[i].asset;
            }
        }
        return '';
    }

    getAssetColour = (assetId) => {
        for (let i = 0; i < this.state.assets.length; i++) {
            if (String(this.state.assets[i].assetId) === String(assetId)) {
                return this.state.assets[i].colour;
            }
        }
        return '';
    }

    handleSetAsset = (category, assetId) => () => {
        //category_update sets every field it is sent, so post the row's current
        //values alongside the new assetId
        fetch('category_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "categoryId=" + category.categoryId + "&title=" + category.title + "&colour=" + category.colour + "&assetId=" + assetId
        })
        .then(res => res.json())
        .then(data => {
            if ('true' === data[0].update) {
                category.assetId = assetId;
                this.setState({ categories: this.state.categories });
            }
        })
        .catch(console.log)
    }

    //the items deliberately stay SafeAnchors (no as="button"): the row is wrapped in the
    //delete form, and a typeless <button> inside it would submit that form
    renderAssetDropdown = (category) => {
        return (
            <Dropdown className="musterCategoryCol">
                <Dropdown.Toggle size="lg" variant="success" id="asset" style={{ backgroundColor: "#" + this.getAssetColour(category.assetId) }}>
                    {this.getAssetName(category.assetId) || 'None'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {this.state.assets.map((asset) => (
                        <Dropdown.Item eventKey={[asset.assetId, category.categoryId]} onSelect={this.handleSetAsset(category, asset.assetId)}>{asset.asset}</Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    //column headings, styled and aligned like the muster point list
    renderHeader = (showAction) => {
        return (
            <div class="card musterHeaderCard">
                <div class="CategoryBody">
                <div class="musterHeaderRow">
                <span class="CategoryMarker musterHeaderSpacer"></span>
                <span class="CategoryItem musterHeading">Title</span>
                <span class="musterHeading musterHeadingCategory">Asset</span>
                {showAction && <span class="musterHeading musterHeadingAction">Action</span>}
                </div>
                </div>
            </div>
        )
    }

    render() {
        const categories = this.state.categories;
        if (1 === this.props.accessLevel)
        {
            return (
                <React.Fragment>
                {this.renderHeader(true)}
                {categories.map((category) => (
                <div class="card">
                    <div class="CategoryBody">
                    <form class="form-inline" name="frmLogout" onSubmit={this.handleDelete(category.categoryId)}>
                    <span class="CategoryMarker" style={{'background-color' : '#' + category.colour}}></span>
                    <h2 class="CategoryItem" onClick={() => this.showUpdateCategory(category)}>{category.title}</h2>
                    { this.renderAssetDropdown(category) }
                    <Button variant="danger" size="lg" type="submit" className="musterActionCol">Delete</Button><input type="hidden" name="categoryId" value={category.categoryId} /></form>
                    </div>
                </div>
                ))}
                <ConfirmDeletePopup ref={this.confirmDeletePopup} />
                </React.Fragment>
            )
        }
        else
        {
            return (
                <React.Fragment>
                {this.renderHeader(false)}
                {categories.map((category) => (
                <div class="card">
                    <div class="CategoryBody">
                    <form class="form-inline" name="frmLogout"  onSubmit={this.handleDelete(category.categoryId)}>
                    <span class="CategoryMarker" style={{'background-color' : '#' + category.colour}}></span>
                    <h2 class="CategoryItem" onClick={() => this.showUpdateCategory(category)}>{category.title}</h2>
                    { this.renderAssetDropdown(category) }
                    </form>
                    </div>
                </div>
                ))}
                </React.Fragment>
            )
        }
    }
}

export default CategoryList;
